import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  open: false,
  title: '',
  subTitle: '',
  onConfirm: null,
  onCancel: null,
  isInfo: false,
  isDanger: false,
};

// -------------------------
// Thunks
// -------------------------

/**
 * Opens the confirm modal
 * Payload: { title, subTitle, onConfirm, onCancel, isInfo, isDanger }
 */
export const openConfirm = createAsyncThunk(
  'confirm/openConfirm',
  async ({ title, subTitle, onConfirm, onCancel, isInfo = false, isDanger = false }, { dispatch }) => {
    if (!title) throw new Error('Title is required');

    dispatch(setTitle(title));
    if (subTitle) dispatch(setSubTitle(subTitle));
    if (onConfirm) dispatch(setOnConfirm(onConfirm));
    if (onCancel) dispatch(setOnCancel(onCancel));
    dispatch(setIsInfo(isInfo));
    dispatch(setIsDanger(isDanger));
    dispatch(setOpen(true));
  }
);

/**
 * Closes the confirm modal and resets all state
 */
export const closeConfirm = createAsyncThunk('confirm/closeConfirm', async (_, { dispatch }) => {
  dispatch(resetConfirmState());
});

// -------------------------
// Slice
// -------------------------
const slice = createSlice({
  name: 'confirm',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setOpen(state, action) {
      state.open = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
    setSubTitle(state, action) {
      state.subTitle = action.payload;
    },
    setOnConfirm(state, action) {
      state.onConfirm = action.payload;
    },
    setOnCancel(state, action) {
      state.onCancel = action.payload;
    },
    setIsInfo(state, action) {
      state.isInfo = action.payload;
    },
    setIsDanger(state, action) {
      state.isDanger = action.payload;
    },
    resetConfirmState(state) {
      state.title = initialState.title;
      state.subTitle = initialState.subTitle;
      state.onConfirm = initialState.onConfirm;
      state.onCancel = initialState.onCancel;
      state.isLoading = initialState.isLoading;
      state.open = initialState.open;
      state.isInfo = initialState.isInfo;
      state.isDanger = initialState.isDanger;
    },
  },
});

// -------------------------
// Exports
// -------------------------
export const {
  setLoading,
  setOpen,
  setTitle,
  setSubTitle,
  setOnConfirm,
  setOnCancel,
  setIsInfo,
  setIsDanger,
  resetConfirmState,
} = slice.actions;

export default slice.reducer;
